export function combineSphAndCyl(odSph, odCyl, osSph, osCyl) {
    const jointOd = odSph > 0 && odCyl < 0 ? odSph : odSph + odCyl;
    const jointOs = osSph > 0 && osCyl < 0 ? osSph : osSph + osCyl;
    return { jointOd, jointOs };
}
export const hasValue = (value) => value !== undefined && value !== null && value !== '' && value !== '0' && value !== '0.00' && value !== 0;
